
import { gql } from '@apollo/client'

// mutation name added
export default gql(`
      mutation updateVirtualPublishRule($id: ID! $isEnabled: Boolean $startDate: AWSDateTime $endDate: AWSDateTime $parentAssetId: ID $project: String $module: String!) {
        updateVirtualPublishRule(
            input:{
              id: $id
              isEnabled: $isEnabled
              publishStartDate: $startDate
              publishEndDate: $endDate
            }
            parentAssetId: $parentAssetId
            project: $project
            module: $module
          ){
            id
            assetId
            group{
              id
            }
            isEnabled
            publishEndDate
            publishStartDate
          }
      }`
)
